export const NO_BREAK_SPACE = '\u00a0';
export const SPACE_SYMBOL = '\u0020';
export const MIDDLE_DOT = '\u00b7';
